import React from 'react';
import { motion } from 'framer-motion';
import { buttonVariants } from '../utils/animations';
import { useTheme, getThemeColors } from '../contexts/ThemeContext';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  magnetic = false,
  onClick,
  href,
  ...props 
}) => {
  const { isDarkMode } = useTheme();
  const colors = getThemeColors(isDarkMode);
  
  const baseClasses = `inline-flex items-center justify-center font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 ${isDarkMode ? 'focus:ring-offset-black' : 'focus:ring-offset-white'}`;
  
  const variants = {
    primary: 'bg-primary-400 text-black hover:bg-primary-300 hover:shadow-magnetic',
    secondary: 'bg-transparent text-primary-400 border-2 border-primary-400 hover:bg-primary-400 hover:text-black',
    ghost: `bg-transparent ${colors.text.primary} border ${colors.border.default} hover:border-primary-400 hover:text-primary-400`,
    text: 'bg-transparent text-primary-400 hover:text-primary-300 underline-offset-4 hover:underline'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm rounded-lg',
    md: 'px-6 py-3 text-base rounded-xl',
    lg: 'px-8 py-4 text-lg rounded-xl',
    xl: 'px-10 py-5 text-xl rounded-2xl'
  };
  
  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;
  
  const MotionComponent = motion[href ? 'a' : 'button'];
  
  return (
    <MotionComponent
      className={classes}
      variants={magnetic ? buttonVariants : undefined}
      initial="rest"
      whileHover="hover"
      whileTap="tap"
      onClick={onClick}
      href={href}
      {...props}
    >
      {children}
    </MotionComponent>
  );
};

export default Button;